import { useEffect } from "react";

const SITE_URL = "https://hireqix.com";
const DEFAULT_IMAGE = `${SITE_URL}/images/og-image.jpg`;

export default function SEO({ title, description, keywords, canonicalPath = "", image = DEFAULT_IMAGE, robots = "index, follow" }) {
  useEffect(() => {
    if (title) document.title = title;

    const setMeta = (attr, key, content) => {
      let el = document.querySelector(`meta[${attr}="${key}"]`);
      if (!el) {
        el = document.createElement("meta");
        el.setAttribute(attr, key);
        document.head.appendChild(el);
      }
      el.setAttribute("content", content);
    };

    const url = `${SITE_URL}${canonicalPath}`;

    if (description) {
      setMeta("name", "description", description);
      setMeta("property", "og:description", description);
      setMeta("name", "twitter:description", description);
    }
    if (keywords) setMeta("name", "keywords", keywords);
    if (title) {
      setMeta("property", "og:title", title);
      setMeta("name", "twitter:title", title);
    }
    setMeta("property", "og:url", url);
    setMeta("property", "og:type", "website");
    setMeta("property", "og:site_name", "hireqix");
    setMeta("property", "og:image", image);
    setMeta("name", "twitter:card", "summary_large_image");
    setMeta("name", "twitter:image", image);
    setMeta("name", "robots", robots);
    setMeta("name", "googlebot", robots);

    let link = document.querySelector('link[rel="canonical"]');
    if (!link) {
      link = document.createElement("link");
      link.setAttribute("rel", "canonical");
      document.head.appendChild(link);
    }
    link.setAttribute("href", url);
  }, [title, description, keywords, canonicalPath, image, robots]);

  return null;
}
